<template>
  <div :class="'fy-preview fy-theme-' + theme">
    <span>{{titlePageLabel}}</span>
  </div>
</template>

<script>

export default {
  name: 'TitlePagePreview',
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  },
  computed: {
    titlePageLabel() {
      switch(this.entity.type) {
        case 'fy_word':
          return '扉页：词汇';
        case 'fy_grammar':
          return '扉页：语法';
        case 'fy_kewen':
          return '扉页：课文';
        case 'fy_test':
          return '扉页：小测试';
        case 'fy_training':
          return '扉页：综合训练';
        case 'iq_word':
          return '自动出题：词汇练习 ' + (this.entity.entity_id || '');
        case 'iq_words':
          return '自动出题：词汇配对 ' + (this.entity.entity_ids || '');
        case 'iq_writing':
          return '自动出题：汉字书写 ' + (this.entity.entity_ids || '');
        case 'iq_sentence':
          return '自动出题：句子练习 ' + (this.entity.entity_id || '');
        case 'iq_repost':
          return '自动出题：错题重推';
      }
      return this.entity.type
    }
  },
}
</script>

<style lang="scss">
.fy-theme-card{
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
  span:first-child{display: none;}
  span:last-child{
    font-size: 24px;
    text-align: center;
  }
}
</style>